export default __webpack_public_path__ + "images/logo-raychem.svg?61c39d80c69128ab3d23b7561aee65df";